import * as themeFiamfaam from './themeFIAMFAAM';
import * as themeFMU from './themeFMU';

const path = window.location.href;
const theme = path.includes('fiamfaam') ? themeFiamfaam : themeFMU

export const {
  BACKGROUND_COLOR,
  DARK_GRAY,
  CORE_COLOR,
  EERIE_BLACK,
  FONT_FAMILY,
  FONT_FAMILY_EXTRABOLD,
  FONT_FAMILY_EXTRALIGHT,
  FONT_FAMILY_REGULAR,
  FONT_FAMILY_SEMIBOLD,
  GRAY,
  LIGHT_GRAY,
  MEDIUM_GRAY,
  OPAQUE_LIGHT_TOMATO,
  TOMATO,
  WHITE,
  LOGO,
} = theme;

export default theme.default;
